/**
 * @author wxw
 * 功能：属性组模块
 */
import { Service } from '@/tools'

export class AttributeGroupService<T extends TCommodity.AttributeGroup> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.AttributeGroup}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 查询属性组列表
  // /api/commodity/attributeGroup/v1/queryAttributeGroupPage
  queryAttributeGroupPage = <K extends T['ApiQueryAttributeGroupPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryAttributeGroupPage', data)

  // 新增属性组
  // /api/commodity/attributeGroup/v1/addCommodityAttributeGroup
  addCommodityAttributeGroupRes = <K extends T['ApiAddCommodityAttributeGroup']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddCommodityAttributeGroup', data)

  // 删除属性组
  // /api/commodity/attributeGroup/v1/deleteCommodityAttributeGroup
  deleteCommodityAttributeGroupRes = <K extends T['ApiDeleteCommodityAttributeGroup']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteCommodityAttributeGroup', data)

  // 更新属性组
  // /api/commodity/attributeGroup/v1/updateCommodityAttributeGroup
  updateCommodityAttributeGroup = <K extends T['ApiUpdateCommodityAttributeGroup']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateCommodityAttributeGroup', data)

  // 属性组状态变更
  // /api/commodity/attributeGroup/v1/stateChangeCommodityAttributeGroup
  stateChangeCommodityAttributeGroup = <K extends T['ApiStateChangeCommodityAttributeGroup']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiStateChangeCommodityAttributeGroup', data)

  // 查询属性组详情
  // /api/commodity/attributeGroup/v1/queryAttributeGroupDetailsList
  queryAttributeGroupDetailsList = <K extends T['ApiQueryAttributeGroupDetailsList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryAttributeGroupDetailsList', data)

}
